import Seo from "@/components/Seo";
import CTAButton from "@/components/CTAButton";

export default function NotFound() {
  return (
    <section className="relative flex min-h-[80vh] items-center justify-center px-5 pt-24">
      <Seo title="Page not found" description="The page you're looking for doesn't exist." path="/404" />
      <div className="text-center">
        <p className="brand-gradient-text font-display text-7xl font-semibold sm:text-8xl">404</p>
        <h1 className="mt-4 font-display text-2xl font-semibold tracking-tight sm:text-3xl">This page took a different path.</h1>
        <p className="mx-auto mt-3 max-w-md text-sm text-muted-foreground">
          The page you're looking for isn't here. Let's get you back to the workspace.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <CTAButton to="/" variant="gradient" size="md">Back home</CTAButton>
          <CTAButton to="/product" variant="outline" size="md">Explore product</CTAButton>
        </div>
      </div>
    </section>
  );
}
